import script from "./TopHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TopHeader.vue?vue&type=script&setup=true&lang=js"

import "./TopHeader.vue?vue&type=style&index=0&id=0ac47d86&lang=css"

const __exports__ = script;

export default __exports__